export default __webpack_public_path__ + "static/media/secretary001.866d5f2d.jpeg";